import { useContext } from 'react';

import { ChartLayoutOrientationContext } from '../context/ChartLayoutOrientation.context.js';

/**
 * @internal
 */
export const useChartLayoutOrientation = () =>
  useContext(ChartLayoutOrientationContext);
